/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

import DS from 'ember-data';
import EnvironmentService from 'cio/services/environment';
import TransactionalMessageModel from 'cio/models/transactional-message';

interface TransactionMessageActionsModalArgs {
  message: TransactionalMessageModel;
  copying: boolean;
  onCopy: (envID: string) => unknown;
  onClose: () => unknown;
}

export default class TransactionMessageActionsModal extends Component<TransactionMessageActionsModalArgs> {
  @service store!: DS.Store;
  @service environment!: EnvironmentService;

  @tracked selectedEnvironmentID = this.environment.current.id;

  get allEnvironments() {
    return this.store.peekAll('environment');
  }

  get environmentDropdownOptions() {
    let environments = this.allEnvironments;

    let environmentOptionsData = environments.map((currentEnvironment) => {
      return {
        label:
          this.environment.current.id === currentEnvironment.id
            ? `${currentEnvironment.name} (current)`
            : currentEnvironment.name,
        value: currentEnvironment.id,
      };
    });

    return environmentOptionsData;
  }

  get environmentData() {
    if (this.selectedEnvironmentID === this.environment.current.id) {
      return;
    }

    return {
      id: this.selectedEnvironmentID,
      name: this.allEnvironments.find((env) => env.id === this.selectedEnvironmentID)?.name,
    };
  }
}
